<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="empresas" v-model="empresaSelecionada" item-text="razao_social"
                            item-value="id_empresa" :label="$t('routs.headers.company')" clearable />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <MultiplaEscolha :items="veiculosItens" v-bind:selected-items.sync="veiculosSelecionados"
                            text="cod_veiculo" value="id_veiculo" :label="$t('nav.registration.vehicles')"
                            :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="linhasItens" v-bind:selected-items.sync="linhasSelecionadas"
                            text="nome_linha" value="id_linha" :label="$t('nav.registration.lines')" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="unidadesItens" v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade" value="id_unidade" :label="$t('nav.registration.units')"
                            :max-items="2" />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$t('relTripDelay.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :date-picker-props="dtiProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-datetime-picker :label="$t('relTripDelay.endDate')" v-model="dtf"
                            :time-picker-props="timeProps" :date-picker-props="dtfProps"
                            :text-field-props="textFieldProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('button.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable ref="viagensTable" :headers="headers" :items="viagensFiltered" :loading="loading"
            :default-multi-sort="defaultSort" :loading-text="$t('relTripDelay.loading')"
            :item-class="rowClass" item-key="id_viagem_grid"

 cod-tabela="RELATRASOVIAGENS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relTripDelay.title')" :token="token" :items="viagensFiltered"
                    csv-title="atrasoviagens" :csv-headers="headers"
                    list-endpoint="getrelatorioatrasoviagens" :request-params="csvExportRequestParams"
                    :post-filters="csvExportPostFilters" :export-total="viagensFiltered.length"
                    id-field="id_viagem_grid"
                    :pdf-title="$t('relTripDelay.title')" :pdf-headers="headers"
                    pdf-filename="atrasoviagens" hide-search>
                </CadastroToolbar>
            </template>
        </MerusDataTable>
    </v-container>
</template>
<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import { inFilter, mergePostFilters, multiSearchToPostFilters } from '@/utils/csvExportPostFilters';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        config: null,
        formValidado: false,
        empresas: [],
        empresaSelecionada: null,
        veiculos: [],
        veiculosSelecionados: [],
        linhas: [],
        linhasSelecionadas: [],
        unidades: [],
        unidadesSelecionadas: [],
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        viagens: [],
        loading: false,
        /** Incrementado após o mount para registrar a dependência reativa do $refs.viagensTable.multiSearch. */
        csvPostFiltersRefreshTick: 0,
    }),
    computed: {
        veiculosItens() {
            return this.empresaSelecionada
                ? this.veiculos.filter((c) => c.id_empresa === this.empresaSelecionada)
                : this.veiculos;
        },
    defaultSort() {
            return [
                { value: 'delay_trip_min', options: { text: this.$t('routs.decreasing'), value: -1 } },
                { value: 'cod_linha', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
        linhasItens() {
            let items = this.empresaSelecionada
                ? this.linhas.filter((g) => g.id_empresa === this.empresaSelecionada)
                : this.linhas;
            if (this.unidadesSelecionadas.length > 0) {
                const set = new Set(this.unidadesSelecionadas.map((id) => Number(id)));
                items = items.filter((l) => {
                    const u = Array.isArray(l.unidades) ? l.unidades : [];
                    return u.some((id) => set.has(Number(id)));
                });
            }
            return items;
        },
        unidadesItens() {
            return this.unidades;
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            };
        },
        linhaIdsPorUnidade() {
            if (this.unidadesSelecionadas.length === 0) {
                return null;
            }
            const set = new Set(this.unidadesSelecionadas.map((id) => Number(id)));
            return new Set(
                this.linhas
                    .filter((l) => {
                        const u = Array.isArray(l.unidades) ? l.unidades : [];
                        return u.some((id) => set.has(Number(id)));
                    })
                    .map((l) => l.id_linha)
            );
        },
        viagensFiltered() {
            let dados = this.viagens;
            if (this.linhasSelecionadas.length > 0) {
                dados = dados.filter((d) => this.linhasSelecionadas.includes(d.id_linha));
            }
            if (this.veiculosSelecionados.length > 0) {
                dados = dados.filter((d) => this.veiculosSelecionados.includes(d.id_veiculo_realizado));
            }
            if (this.linhaIdsPorUnidade) {
                dados = dados.filter((d) => this.linhaIdsPorUnidade.has(d.id_linha));
            }
            return dados;
        },
        /** Mesmo body enviado a getRelatorioatrasoviagens; reexecutado pelo worker de export CSV. */
        csvExportRequestParams() {
            if (!this.dti || !this.dtf) return {};
            return {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf),
                id_empresa: this.empresaSelecionada || null,
                id_linhas: this.linhasSelecionadas.length ? this.linhasSelecionadas : null,
                id_veiculos: this.veiculosSelecionados.length ? this.veiculosSelecionados : null,
            };
        },
        /** postFilters da toolbar CSV: espelha viagensFiltered (linhasSelecionadas ∩ linhaIdsPorUnidade). */
        csvExportPostFilters() {
            void this.csvPostFiltersRefreshTick;
            const a = this.linhasSelecionadas.length > 0 ? this.linhasSelecionadas : null;
            const b = this.linhaIdsPorUnidade ? Array.from(this.linhaIdsPorUnidade) : null;
            let idLinhaFilter = {};
            if (a && b) {
                const setB = new Set(b);
                idLinhaFilter = inFilter('id_linha', a.filter((id) => setB.has(id)));
            } else if (a || b) {
                idLinhaFilter = inFilter('id_linha', a || b);
            }
            const tableRef = this.$refs.viagensTable;
            const multiSearchFilters = tableRef ? multiSearchToPostFilters(tableRef.multiSearch) : {};
            return mergePostFilters(
                idLinhaFilter,
                inFilter('id_veiculo_realizado', this.veiculosSelecionados),
                multiSearchFilters
            );
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    mounted() {
        // Força uma reavaliação de csvExportPostFilters após o mount, para que a
        // dependência reativa em $refs.viagensTable.multiSearch seja registrada.
        this.$nextTick(() => { this.csvPostFiltersRefreshTick++; });
    },
    methods: {

        rowClass(item) {
            if (item && Number(item.delay_trip_min) > 0) {
                return 'rel-trip-delay--late';
            }
            return '';
        },
        initialize() {
            this.getConfig();
            this.populaEmpresas();
            this.populaLinhas();
            this.populaVeiculos();
            this.populaUnidades();
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                }
            });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                onSuccess: (response) => {
                    this.empresas = response.data;
                }
            });
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data;
                }
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                onSuccess: (response) => {
                    this.veiculos = response.data;
                }
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [
                        { id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' },
                        ...(response.data || [])];
                }
            });
        },
        populaRelatorio() {
            this.$refs.form.validate();
            if (!this.dti || !this.dtf) {
                return;
            }
            this.loading = true;
            const dti = DateUtils.getDateSQLFormatted(this.dti);
            const dtf = DateUtils.getDateSQLFormatted(this.dtf);
            const body = {
                dti,
                dtf,
                id_empresa: this.empresaSelecionada || null,
                id_linhas: this.linhasSelecionadas.length ? this.linhasSelecionadas : null,
                id_veiculos: this.veiculosSelecionados.length ? this.veiculosSelecionados : null,
            };

            apiController.request(apiController.endpoints.getRelatorioatrasoviagens, {
                data: body,
                onSuccess: (response) => {
                    this.viagens = response.data || [];
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
    },
};
</script>
<style scoped>
::v-deep tr.rel-trip-delay--late {
    background-color: #ffebee !important;
}
</style>
